import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=d048dd46&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=js&"
export * from "./AuthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048dd46",
  null
  
)

export default component.exports